const InvestingSectionContainer = ({ width }) => {
  return (
    <div style={{ width: width }} className="absolute top-[2942px] left-[0px] bg-cash-app-green w-[1366px] h-[750px] overflow-hidden text-left text-3xl text-black font-hero-text">
      <img
        className="absolute top-[452px] left-[0px] w-[2336px] h-[496px] overflow-hidden"
        alt=""
        src="/investingfloor-1.svg"
      />
      <img
        className="absolute h-[181.6%] w-full top-[0%] right-[0%] bottom-[-81.6%] left-[0%] max-w-full overflow-hidden max-h-full"
        alt=""
        src="/investingrays-1.svg"
      />
      <img
        className="absolute h-[54.8%] w-[62.15%] top-[16.4%] right-[-43.48%] bottom-[28.8%] left-[81.33%] max-w-full overflow-hidden max-h-full object-cover"
        alt=""
        src="/investinggraph2@2x.png"
      />
      <img
        className="absolute h-[37.73%] w-[74.96%] top-[58.13%] right-[25.04%] bottom-[4.13%] left-[0%] max-w-full overflow-hidden max-h-full object-cover"
        alt=""
        src="/investinggraph1@2x.png"
      />
      <div className="absolute top-[calc(50%_-_87px)] left-[calc(50%_-_588px)] w-[352px] h-[136px]">
        <div className="absolute top-[0px] left-[calc(50%_-_176px)] leading-[40px] inline-block w-[336px]">
          Stocks
        </div>
        <div className="absolute top-[calc(50%_-_20px)] left-[calc(50%_-_176px)] text-base tracking-[0.3px] leading-[22px] font-body-1-regular-16-22-03px inline-block w-[352px] h-[88px]">
          Whether you’re an expert or just getting started, Cash App is the
          fastest and most accessible way to invest in stocks. Start now with as
          little as $1.
        </div>
      </div>
      <div className="absolute top-[calc(50%_-_87px)] left-[calc(50%_+_260px)] w-[336px] h-[136px]">
        <div className="absolute top-[0px] left-[calc(50%_-_168px)] leading-[40px] inline-block w-[336px]">
          Bitcoin
        </div>
        <div className="absolute top-[calc(50%_-_20px)] left-[calc(50%_-_168px)] text-base tracking-[0.3px] leading-[22px] font-body-1-regular-16-22-03px inline-block w-[336px] h-[88px]">
          Cash App is the fastest way to convert dollars to bitcoin. From your
          home screen, six taps are all it takes to stack sats, buy an entire
          bitcoin, or just see what it’s all about.
        </div>
      </div>
      <div className="absolute top-[131px] left-[calc(50%_-_129px)] text-21xl leading-[40px] text-light-white inline-block w-[258px]">
        Investing
      </div>
      <img
        className="absolute top-[252px] left-[484px] w-40 h-[344px] object-cover"
        alt=""
        src="/investingstocks@2x.png"
      />
      <img
        className="absolute top-[254px] left-[722px] w-40 h-[346.89px] object-cover"
        alt=""
        src="/investingbitcoin@2x.png"
      />
      <div className="absolute w-[calc(100%_-_123px)] top-[680px] right-[62px] left-[61px] h-[65px] overflow-hidden text-3xs text-dimgray font-body-1-regular-16-22-03px">
        <div className="absolute top-[calc(50%_-_24.5px)] left-[calc(50%_-_621.5px)] flex flex-col items-center justify-start">
          <div className="flex flex-row items-center justify-start gap-[20px]">
            <button className="cursor-pointer p-[25px] bg-light-white rounded-6xs box-border w-[170px] h-[50px] flex flex-row items-center justify-between border-[1px] border-solid border-black">
              <img
                className="relative w-[19.22px] h-[22.82px]"
                alt=""
                src="/vector7.svg"
              />
              <label className="cursor-pointer relative text-xs tracking-[0.5px] leading-[18px] uppercase font-hero-text text-black text-center">
                APP STORE
              </label>
            </button>
            <button className="cursor-pointer p-3 bg-light-white rounded-6xs box-border w-[170px] h-[50px] flex flex-row items-center justify-between border-[1px] border-solid border-black">
              <img
                className="relative w-[19.45px] h-[21.22px]"
                alt=""
                src="/vector8.svg"
              />
              <label className="cursor-pointer relative text-xs tracking-[0.5px] leading-[18px] uppercase font-hero-text text-black text-center">
                GOOGLE PLAY
              </label>
            </button>
          </div>
        </div>
        <div className="absolute top-[0px] left-[calc(50%_+_96.5px)] flex flex-col items-center justify-start">
          <div className="relative leading-[13px] inline-block w-[363px]">
            <p className="m-0">
              Brokerage services by Cash App Investing LLC, member FINRA / SIPC.
            </p>
            <p className="m-0">
              See our BrokerCheck. Investing involves risk; you may lose money.
              Bitcoin trading offered by Cash App. Cash App Investing does not
              trade bitcoin and Cash App is not a member of FINRA or SIPC. Cash
              App facilitates banking services through Sutton Bank and Lincoln
              Savings Bank, Members FDIC.
            </p>
          </div>
        </div>
        <div className="absolute top-[21px] left-[calc(50%_+_495px)] flex flex-row items-center justify-start gap-[30px]">
          <button className="cursor-pointer [border:none] p-0 bg-[transparent] relative w-6 h-6 overflow-hidden shrink-0">
            <img
              className="absolute h-full w-[95.53%] top-[0%] right-[2.24%] bottom-[0%] left-[2.24%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector9.svg"
            />
          </button>
          <button className="cursor-pointer [border:none] p-0 bg-[transparent] relative w-[21px] h-[17px] overflow-hidden shrink-0">
            <img
              className="absolute h-[99.67%] w-[99.27%] top-[0%] right-[0.73%] bottom-[0.33%] left-[0%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector10.svg"
            />
          </button>
          <button className="cursor-pointer [border:none] p-0 bg-[transparent] relative w-[21px] h-[21px] overflow-hidden shrink-0">
            <img
              className="absolute h-[95.03%] w-[95.05%] top-[2.4%] right-[2.26%] bottom-[2.57%] left-[2.69%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector11.svg"
            />
            <img
              className="absolute h-[48.81%] w-[48.81%] top-[25.5%] right-[25.4%] bottom-[25.69%] left-[25.8%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector12.svg"
            />
            <img
              className="absolute h-[11.39%] w-[11.39%] top-[18.85%] right-[18.74%] bottom-[69.76%] left-[69.87%] max-w-full overflow-hidden max-h-full"
              alt=""
              src="/vector13.svg"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvestingSectionContainer;
